// extracted by mini-css-extract-plugin
module.exports = {"title":"title-1986LW-R","cut":"cut-2N3WKz2H","name":"name-211nYXLX"};